// extracted by mini-css-extract-plugin
export var icon = "index-module--icon--b604f";
export var iframe = "index-module--iframe--60a8a";
export var image = "index-module--image--d0361";
export var link = "index-module--link--00a5d";
export var table = "index-module--table--17b51";
export var tableWrap = "index-module--tableWrap--8be81";